import * as zod from 'zod';

import { OR2FG14GripKind } from '../constants';

import { OnRobot2FG14FingerConfiguration } from './OnRobot2FG14FingerConfiguration';

const widthState = zod.object({
  // meters
  inner: zod.number(),
  // meters
  outer: zod.number(),
});

export const OnRobot2FG14State = zod.object({
  kind: zod.literal('OnRobot2FG14'),
  error: zod.string().optional(),
  isConnected: zod.boolean(),
  isBusy: zod.boolean(),

  isGripDetected: zod.boolean(),
  // newtons
  force: zod.number().nonnegative(),
  // newtons
  maxForce: zod.number().nonnegative(),

  width: widthState,
  maxWidth: widthState,
  minWidth: widthState,

  gripKind: OR2FG14GripKind.optional(),

  fingerConfiguration: OnRobot2FG14FingerConfiguration,
  // meters
  fingerLength: zod.number().nonnegative(),
  // meters
  fingerHeight: zod.number().nonnegative(),

  // errors
  linearSensorError: zod.boolean(),
  uncalibratedError: zod.boolean(),
});

export type OnRobot2FG14State = zod.infer<typeof OnRobot2FG14State>;
